import { commonMessages } from '../../util/messages'

export const messages = {
  common: commonMessages,
  create: {
    success: 'User created successfully. Now you can link the user to a tenant',
    error: 'Error crating the user',
  },
  user: {
    updated: 'User updated successfully',
    updateError: 'Error updating the user',
    enabled: 'User successfully enabled to the tenant',
    changedRole: 'Successfully changed role to the tenant',
    updateTenantError: 'Error updating the tenant to the user',
    deletedTenantAccess: 'Successfully removed the user access to the tenant',
    deletedTenantAccessError: 'Error removing the user access to the tenant',
    resendPassword: 'An E-mail with the new temporary password has been sent to the user',
    resendPasswordError: 'Cannot send temporary password. User has already set their own password',
  },
  extendPasswordExpiry: {
    success: 'Password expiry successfully extended',
    error: 'Error extending password expiry',
  },
}
